import { graphql } from "relay-runtime"

export const de_VerifyMedicationQuery = graphql`
  query deVerifyMedicationQuery($appointmentId: ID!, $patientId: ID!, $skip: Boolean!) {
    medicationVerification: de_medicationVerification(appointmentId: $appointmentId, patientId: $patientId)
      @skip(if: $skip) {
      ... on de_SuccessMedicationVerificationResult {
        result {
          isVerified
          patientId
          currentAppointmentId
          lastVerifiedAt
          lastVerifiedBy
          lastVerifyMedicationStatus
        }
      }
    }
  }
`
